import { useState } from 'react';
import { employeeApi } from '../../../lib/api';
import { deviceMeta, tryGetIP, getCurrentPosition } from '../../../lib/photo';
import { useEmployee } from '../EmployeeContext';
import { useSession } from '../../../context/SessionContext';
import { errorMessage } from '../../../components/ErrorModalBody';

export function ConsentScreen() {
  const { employee, termoTexto, refresh } = useEmployee();
  const { logout } = useSession();
  const [nome, setNome] = useState('');
  const [agree, setAgree] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function accept() {
    if (nome.trim().toLowerCase() !== employee.nome.trim().toLowerCase()) {
      setError('O nome digitado precisa ser igual ao seu nome de cadastro: ' + employee.nome);
      return;
    }
    if (!agree) {
      setError('Marque que você leu e concorda com o termo.');
      return;
    }
    setBusy(true);
    setError('');
    try {
      let geo: { lat: number; lng: number } | null = null;
      try {
        const pos = await getCurrentPosition();
        geo = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      } catch { /* geo opcional no aceite */ }
      const ip = await tryGetIP();
      await employeeApi.acceptConsent({ nomeDigitado: nome.trim(), geo, ip, device: deviceMeta() });
      await refresh();
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="card login-card" style={{ maxWidth: 540, textAlign: 'left' }}>
        <h2>Termo de aceite — meios eletrônicos</h2>
        <p className="hint">Leia com atenção antes de continuar.</p>
        <div className="doc-text">{termoTexto}</div>
        <label>Digite seu nome completo para confirmar</label>
        <input type="text" placeholder={employee.nome} value={nome} onChange={(e) => setNome(e.target.value)} />
        <label className="checkrow"><input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} /> Li e concordo com o termo acima</label>
        {error && <div className="err">{error}</div>}
        <button className="btn btn-primary btn-block" style={{ marginTop: 14 }} disabled={busy} onClick={accept}>Aceitar e continuar</button>
        <div className="switch-role" style={{ marginTop: 10 }}><a onClick={logout}>Sair</a></div>
      </div>
    </div>
  );
}
